import { IListingPhotos } from '@llws/lift-entity-interfaces';
import app from '@/main';

export const getNewListingPhoto = (clientId: number, buildingId: number, image: string, height: string, width: string): IListingPhotos => ({
  clientId,
  buildingId,
  image,
  height: parseInt(height, 10),
  width: parseInt(width, 10),
  created: new Date(),
  createdUserId: parseInt(app()?.$rsGlobals.$currentUser.userId || '0', 10),
  active: 1,
} as IListingPhotos);
